import type { ProductCategory, ProductUpdate, UpdateCategory } from '@product-updates/shared-types';

export interface Badge {
  category: ProductCategory | UpdateCategory;
  type: 'product' | 'update';
}

export function buildBadges(article: ProductUpdate): Badge[] {
  const badges: Badge[] = [];

  const hasComingSoon = article.updateCategories.includes('Coming soon');

  if (hasComingSoon) {
    badges.push({ category: 'Coming soon', type: 'update' });
  } else if (article.updateCategories.includes('New')) {
    badges.push({ category: 'New', type: 'update' });
  }

  // Product categories
  for (const category of article.productCategories) {
    badges.push({ category, type: 'product' });
  }

  // Remaining update categories
  for (const category of article.updateCategories) {
    if (category !== 'New' && category !== 'Coming soon') {
      badges.push({ category, type: 'update' });
    }
  }

  return badges;
}
